import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { fetchReport, clearReport } from '../../actions/report'
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import Icon from '@material-ui/core/Icon';
import Fab from '@material-ui/core/Fab';
import moment from 'moment';
import 'moment/locale/uk';
import { connect } from 'react-redux';
import b64toBlob from './../../utils/b64toBlob';
import FileDownload from 'js-file-download'

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  container: {
    marginTop: '2rem',
    padding: '20px',
    maxWidth: '980px',
    margin: '0 auto'
  },
  date: {
    padding: '0 1rem'
  },
  fab: {
    margin: theme.spacing.unit,
  },
})

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class ReportDialog extends React.Component {

  state = {
    date_start: null,
    date_end: null
  }

  handleDateFromChange = date => {
    this.setState({ date_start: date });
  };
  handleDateToChange = date => {
    this.setState({ date_end: date });
  };

  handleClickOpen = () => {
    this.props.handleReportDialog(true)
  };

  handleClose = () => {
    this.props.handleReportDialog(false)
  };

  handleReport = () => {
    const { date_start, date_end } = this.state
    this.props.fetchReport({ date_start: date_start.format('DD-MM-YYYY'), date_end: date_end.format('DD-MM-YYYY') })
  }

  handleDownload = () => {
    const { data: { content } } = this.props
    const { date_start, date_end } = this.state
    const file = b64toBlob(content, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 512)
    const fileName = `${date_start.format('DD-MM-YYYY')}-${date_end.format('DD-MM-YYYY')}.xlsx`
    FileDownload(file, fileName)
  }

  validateDates = () => {
    const { date_start, date_end } = this.state
    if (date_start && date_end) {
      if (!date_start.isValid() || !date_end.isValid()) {
        return true
      }
      return false
    }

    return true
  }

  render() {
    const { classes, report, data } = this.props;
    const { date_end, date_start } = this.state

    return (
      <React.Fragment>
        <Dialog
          fullScreen
          open={report}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                Сформувати звіт
              </Typography>
            </Toolbar>
          </AppBar>
          <Grid container className={classes.container}>
            <Grid item xs={5} className={classes.date}>
              <MuiPickersUtilsProvider
                utils={MomentUtils}
                moment={moment}>
                <DatePicker
                  keyboard
                  value={date_start}
                  onChange={this.handleDateFromChange}
                  format='DD.MM.YYYY'
                  name="date_start"
                  label="Дата з"
                  placeholder="01.01.2019"
                  disableOpenOnEnter
                  mask={value =>
                    value ? [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/] : []
                  }
                  invalidDateMessage={'Недійсний формат дати'}
                  clearLabel='Очистити'
                  cancelLabel='Скасувати'
                  clearable
                  autoOk
                  fullWidth
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={5} className={classes.date}>
              <MuiPickersUtilsProvider
                utils={MomentUtils}
                moment={moment}>
                <DatePicker
                  keyboard
                  value={date_end}
                  onChange={this.handleDateToChange}
                  format='DD.MM.YYYY'
                  name="date_start"
                  placeholder="01.01.2019"
                  mask={value =>
                    value ? [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/] : []
                  }
                  label="Дата по"
                  disableOpenOnEnter
                  minDateMessage="Дата не повинна бути за дату 'Дату з' "
                  invalidDateMessage={'Недійсний формат дати'}
                  minDate={date_start}
                  clearLabel='Очистити'
                  cancelLabel='Скасувати'
                  clearable
                  autoOk
                  fullWidth
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={1}>
              <Fab color="secondary" disabled={this.validateDates()} aria-label="Publish" className={classes.fab} onClick={this.handleReport}>
                <Icon>publish</Icon>
              </Fab>
            </Grid>
            {data.loaded && <Grid item xs={1}>
              <Fab color="primary" aria-label="Download" className={classes.fab} onClick={this.handleDownload}>
                <Icon>attach_file</Icon>
              </Fab>
            </Grid>}
          </Grid>
        </Dialog>
      </React.Fragment>
    );
  }
}

ReportDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect((state) => ({
  data: state.report
}), { fetchReport, clearReport })(withStyles(styles)(ReportDialog))


// WEBPACK FOOTER //
// ./src/components/ReportDialog/ReportDialog.js